// Initialise Slick carousels.
// slick.min.js is loaded as a plain <script> and registers itself on the page's
// global jQuery, not the copy of jQuery that gets bundled into app.bundle.js,
// so use the global one here or $(...).slick is undefined.
const $ = window.jQuery;

export default function slickCarousel (target) {
	$(document).ready(function(){
		$(target).slick({
			dots: true,
			lazyLoad: 'ondemand'
		});
	});
}